import { ShareDialog } from 'components/ShareDialog'
import styles from './ShareButton.module.css'
import { ShareIcon } from 'shared/icons/ShareIcon'
import { useState } from 'react'

interface ShareButtonProps {
}

export const ShareButton = (props: ShareButtonProps): JSX.Element => {
    const [openShareDialog, setOpenShareDialog] = useState(false)

    const handleButtonClick = () => {
        setOpenShareDialog(true)
    }

    const handleCancelShareDialog = () => {
        setOpenShareDialog(false)
    }

    return (
        <>
            <button
                className={styles.ShareButton}
                onClick={handleButtonClick}
            >
                <span
                    className={styles.ShareButton__IconContainer}
                >
                    <ShareIcon className={styles.ShareButton__Icon} />
                </span>

                <span className={styles.ShareButton__CaptionContainer}>
                    <span
                        className={styles.ShareButton__Caption}
                    >
                        Share App
                    </span>
                </span>
            </button>
            <ShareDialog
                keepMounted={true}
                open={openShareDialog}
                onClose={handleCancelShareDialog}
                onCancel={handleCancelShareDialog}
            />
        </>
    )
}